import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=c938dbe6&scoped=true&"
import script from "./QuestionList.vue?vue&type=script&lang=js&"
export * from "./QuestionList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=c938dbe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c938dbe6",
  null
  
)

export default component.exports